const SET_ORDER_INTERVAL = 'SET_ORDER_INTERVAL';
const OrderIntervalSymbols = {
  SET_ORDER_INTERVAL,
};
export default OrderIntervalSymbols;